import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import tw from "tailwind-styled-components";
import Images from "../../../Images";

const DropZone = ({ setFieldValue, File }) => {
  const [files, setFiles] = useState(File || []);

  const onDrop = useCallback(
    (acceptedFiles) => {
      const newFiles = [...files, ...acceptedFiles];

      setFiles(newFiles);
      setFieldValue("files", newFiles);
    },
    [files, setFieldValue]
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: true,
    // maxSize: 26214400,
    accept:".jpg,.jpeg,.png,.webp",
  });

  const removeFile = (index) => {
    const updated = [...files];
    updated.splice(index, 1);

    setFiles(updated);
    setFieldValue("files", updated);
  };

  return (
    <UploadBox {...getRootProps()}>
      <input {...getInputProps()} />

      {files.length === 0 ? (
        <UploadText>
          <img src={Images.Upload} alt="" className="w-5 mb-1" />
          <p className="text-xs">Click or Drag Images To Upload</p>
          <span className="text-xs">
            (JPG, PNG, JPEG, WEBP)
          </span>
        </UploadText>
      ) : (
        <FileContainer>
          {files.map((file, index) => (
            <FileItem key={index}>
              {file.name}

              <RemoveBtn
                onClick={(e) => {
                  e.stopPropagation();
                  removeFile(index);
                }}
              >
                <img src={Images.Cross} className="w-2" alt="" />
              </RemoveBtn>
            </FileItem>
            
          ))}
           <div className="text-sm text-primary-color font-bold text-center underline hover:text-blue-600">Click to upload more...</div>
        </FileContainer>
      )}
    </UploadBox>
  );
};

const UploadBox = tw.div`
w-full min-h-[120px] border-2 borde border-gray-300 
bg-gray-50 rounded-md p-4 cursor-pointer
`;

const UploadText = tw.div`
flex flex-col items-center justify-center text-gray-600 text-sm h-full
`;

const FileContainer = tw.div`
flex flex-col gap-2
`;

const FileItem = tw.div`
flex justify-between items-center bg-gray-100 
p-2 rounded text-sm text-gray-600
`;

const RemoveBtn = tw.div`
bg-black w-5 h-5 rounded-full flex items-center justify-center cursor-pointer
`;

export default DropZone;




















// import React, { useState, useCallback, useEffect } from "react";
// import { useDropzone } from "react-dropzone";
// import tw from "tailwind-styled-components";
// import Images from "../../../Images";

// const DropZone = ({ setFieldValue, componentFor, setUploadFile }) => {
//   const [files, setFiles] = useState([]);

//   // Update Formik or parent whenever files change
//   useEffect(() => {
//     if (componentFor === "profile") {
//       setFieldValue("media", files);
//     } else if (componentFor === "expense") {
//       setFieldValue("file", files);
//     } else if (componentFor === "admin") {
//       setUploadFile(files);
//     } else {
//       setFieldValue("files", files); // for general use in forms
//     }
//   }, [files, setFieldValue, setUploadFile, componentFor]);

//   const onDrop = useCallback((acceptedFiles) => {
//     if (acceptedFiles.length > 0) {
//       const mappedFiles = acceptedFiles.map((file) =>
//         Object.assign(file, {
//           preview: URL.createObjectURL(file),
//         })
//       );
//       setFiles((prev) => [...prev, ...mappedFiles]);
//     }
//   }, []);

//   const removeFile = (index) => {
//     setFiles((prev) => prev.filter((_, i) => i !== index));
//   };

//   const { getRootProps, getInputProps, isDragActive } = useDropzone({
//     onDrop,
//     accept: ".jpg,.jpeg,.png,.webp",
//     maxSize: 26214400,
//     multiple: true,
//   });

//   return (
//     <>
//       {/* Dropzone Input */}
//       <div
//         {...getRootProps()}
//         className="w-full bg-gray-50 rounded-md border-2 border-gray-200 cursor-pointer"
//       >
//         <input {...getInputProps()} />
//         <div
//           className={`w-full grid place-content-center p-5 ${
//             isDragActive ? "bg-gray-300" : ""
//           }`}
//         >
//           <TextWrapper>
//             <img src={Images.Upload} alt="upload-icon" className="w-5 mb-1" />
//             <p>{isDragActive ? "Drop Images Here" : "Click or Drag Images To Upload"}</p>
//             <p>(JPG, PNG, JPEG, WEBP)</p>
//           </TextWrapper>
//         </div>
//       </div>

//       {/* Display Selected File Names */}
//       {files.length > 0 && (
//         <FileNameContainer>
//           {files.map((file, index) => (
//             <FileItem key={index}>
//               <span>{file.name}</span>
//               <RemoveBtn onClick={() => removeFile(index)}>
//                 <img src={Images.Cross} className="w-2" />
//               </RemoveBtn>
//             </FileItem>
//           ))}
//         </FileNameContainer>
//       )}

//       {/* Optional Image Preview */}
//       {files.length > 0 && (
//         <PreviewGrid>
//           {files.map((file, index) => (
//             <PreviewBox key={index}>
//               <RemoveBtn onClick={() => removeFile(index)}>
//                 <img src={Images.Cross} className="w-2" />
//               </RemoveBtn>
//               <img
//                 src={file.preview}
//                 alt="preview"
//                 className="object-cover w-full h-full rounded"
//               />
//             </PreviewBox>
//           ))}
//         </PreviewGrid>
//       )}
//     </>
//   );
// };

// // ================= STYLED COMPONENTS =================
// const TextWrapper = tw.div`
// bg-gray-100 upload-fonts w-full rounded-lg text-gray-600 flex flex-col items-center py-5 px-5 gap-2 cursor-pointer
// `;

// const FileNameContainer = tw.div`
// mt-3 flex flex-col gap-2
// `;

// const FileItem = tw.div`
// relative w-full bg-gray-100 text-gray-700 rounded-md p-2 flex justify-between items-center text-sm
// `;

// const RemoveBtn = tw.div`
// w-5 h-5 rounded-full grid place-items-center cursor-pointer bg-black text-white
// `;

// const PreviewGrid = tw.div`
// grid grid-cols-4 gap-3 mt-3
// `;

// const PreviewBox = tw.div`
// w-28 h-28 relative
// `;

// export default DropZone;

// import React, { useState, useCallback, useEffect } from "react";
// import { useDropzone } from "react-dropzone";
// import tw from "tailwind-styled-components";
// import Images from "../../../Images";

// const DropZone = ({ setFieldValue }) => {
//   const [files, setFiles] = useState([]);

//   useEffect(() => {
//     setFieldValue("files", files);
//   }, [files]);

//   const onDrop = useCallback((acceptedFiles) => {
//     const mappedFiles = acceptedFiles.map((file) =>
//       Object.assign(file, {
//         preview: URL.createObjectURL(file),
//       })
//     );

//     setFiles((prev) => [...prev, ...mappedFiles]);
//   }, []);

//   const { getRootProps, getInputProps, isDragActive } = useDropzone({
//     onDrop,
//     accept: {
//       "image/jpeg": [],
//       "image/png": [],
//       "image/jpg": [],
//       "image/webp": [],
//     },
//     maxSize: 26214400, // 25MB
//     multiple: true,
//   });

//   const removeImage = (index) => {
//     const updated = files.filter((_, i) => i !== index);
//     setFiles(updated);
//   };

//   return (
//     <>
//       {/* Upload Area */}
//       <div
//         {...getRootProps()}
//         className="w-full bg-gray-50 rounded-md border-2 border-gray-200"
//       >
//         <input {...getInputProps()} />

//         <div
//           className={`w-full grid place-content-center p-5 ${
//             isDragActive ? "bg-gray-300" : ""
//           }`}
//         >
//           <TextWrapper>
//             <img src={Images.Upload} alt="upload-icon" className="w-5" />
//             <p>
//               {isDragActive
//                 ? "Drop Images Here"
//                 : "Click or Drag Images To Upload"}
//             </p>
//             <p>(JPG, PNG, JPEG, WEBP)</p>
//           </TextWrapper>
//         </div>
//       </div>

//       {/* Preview Images */}
//       {files.length > 0 && (
//         <PreviewGrid>
//           {files.map((file, index) => (
//             <PreviewBox key={index}>
//               <RemoveBtn onClick={() => removeImage(index)}>
//                 <img src={Images.Cross} className="w-2" />
//               </RemoveBtn>

//               <img
//                 src={file.preview}
//                 className="object-cover w-full h-full rounded"
//                 alt="preview"
//               />
//             </PreviewBox>
//           ))}
//         </PreviewGrid>
//       )}
//     </>
//   );
// };

// const TextWrapper = tw.div`
// bg-gray-100 upload-fonts w-full rounded-lg text-gray-600 flex flex-col items-center py-5 px-5 gap-2 cursor-pointer
// `;

// const PreviewGrid = tw.div`
// grid grid-cols-4 gap-3 mt-3
// `;

// const PreviewBox = tw.div`
// w-24 h-24 relative
// `;

// const RemoveBtn = tw.div`
// absolute top-1 right-1 w-5 h-5 rounded-full grid place-items-center cursor-pointer bg-black
// `;

// export default DropZone;
